module.exports = __webpack_public_path__ + "static/media/suki-muted.b86f50f6.png";